/**
 * @module events/types/resize
 */

/**
 * @type {string}
 */
export default 'resize'
